import { render, staticRenderFns } from "./LifeHud.vue?vue&type=template&id=8cdc98be&"
import script from "./LifeHud.vue?vue&type=script&lang=js&"
export * from "./LifeHud.vue?vue&type=script&lang=js&"
import style0 from "./LifeHud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports